import React from "react";
import { useHistory } from 'react-router-dom';

import {
  Container,
  Thumbnail,
  DivisionThumbnail,
  Title,
  Time,
  Desktop,
  Mobile,
  Right,
} from "./styles";

export default function Item({ video, index }) {
  const history = useHistory();

  return (
    <Container onClick={() => history.push(`/treinamentos/video?index=${index}`)}>
      <Desktop>
        <Thumbnail src={video.video_thumbnail} alt="Vídeo thumbnail" />
        <Title>{video.video_titulo}</Title>
        <Time>{Math.round(video.video_duracao / 60)} min</Time>
      </Desktop>
      <Mobile>
        <DivisionThumbnail>
          <Thumbnail src={video.video_thumbnail} alt="Vídeo thumbnail" />
        </DivisionThumbnail>
        <Right>
          <Title>{video.video_titulo}</Title>
          <Time>{Math.round(video.video_duracao / 60)} min</Time>
        </Right>
      </Mobile>
    </Container>
  );
}